<template>
<VueSelect
  v-model="valueAccessor"
  v-bind="selectFieldCommonVueSecectProps"
  class="select-feature-field"
/>
</template>

<script>
import AbstractFeatureField from './AbstractFeatureField'
import VueSelect from 'vue-select';
import selectFieldCommonVueSecectProps from './selectFieldCommonVueSecectProps';

export default AbstractFeatureField.extend({
  components: {
    VueSelect,
  },
  props: {
    value: String,
  },
  computed: {
    selectFieldCommonVueSecectProps,
  },
})
</script>
